import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { useLocation, Link } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "FAQ", href: "/faq" },
    { label: "Contact", href: "/contact" },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMobileNavClick = () => {
    scrollToTop();
    setIsMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 p-4 transition-all duration-300`}
    >
      <div className="container mx-auto">
        <div
          className={`max-w-7xl mx-auto rounded-2xl transition-all duration-300 px-6 py-4
          bg-cloud-white shadow-lg border border-misty-sage/20`}
        >
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link
              to="/"
              className="flex items-center gap-3 hover:opacity-80 transition-all duration-300"
              onClick={scrollToTop}
            >
              <img
                src="/logo-new.svg"
                alt="Cittasya® Logo"
                className="h-14 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.href}
                  className={`text-forest-green hover:text-soft-saffron transition-colors duration-200 font-medium border-b-2 border-transparent hover:border-soft-saffron pb-1 ${
                    location.pathname === item.href
                      ? "text-soft-saffron border-soft-saffron"
                      : ""
                  }`}
                  onClick={scrollToTop}
                >
                  {item.label}
                </Link>
              ))}
            </div>

            {/* CTA Button - Hidden on mobile */}
            <div className="hidden md:block">
              <Button className="bg-forest-green hover:bg-copper-brown text-cloud-white px-6 py-2 rounded-full transition-all duration-300">
                Download App
              </Button>
            </div>

            {/* Hamburger Menu Button */}
            <button
              className="md:hidden p-1 transition-all duration-300 text-forest-green"
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <div
                className={`w-4 h-3 relative transform transition-all duration-300 ${
                  isMenuOpen ? "rotate-180" : ""
                }`}
              >
                <span
                  className={`absolute h-[1px] w-full bg-current transform transition-all duration-300 ${
                    isMenuOpen ? "rotate-45 translate-y-1" : ""
                  }`}
                ></span>
                <span
                  className={`absolute h-[1px] w-full bg-current transform transition-all duration-300 top-[5px] ${
                    isMenuOpen ? "opacity-0" : ""
                  }`}
                ></span>
                <span
                  className={`absolute h-[1px] w-full bg-current transform transition-all duration-300 top-[10px] ${
                    isMenuOpen ? "-rotate-45 -translate-y-1" : ""
                  }`}
                ></span>
              </div>
            </button>
          </div>

          {/* Mobile Navigation Menu */}
          <div
            className={`md:hidden transition-all duration-300 overflow-hidden ${
              isMenuOpen ? "max-h-64 mt-4" : "max-h-0"
            }`}
          >
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.href}
                  className={`text-forest-green hover:text-soft-saffron transition-colors duration-200 font-medium ${
                    location.pathname === item.href ? "text-soft-saffron" : ""
                  }`}
                  onClick={handleMobileNavClick}
                >
                  {item.label}
                </Link>
              ))}
              <Button className="bg-forest-green hover:bg-copper-brown text-cloud-white px-6 py-2 rounded-full transition-all duration-300 w-full">
                Download App
              </Button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
